import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ProgressComponent from "../../components/general/ProgressComponent";
import {
    getRecords,
    isSuccess,
    catchAsync,
    filterColumns,
    filterRowsByProperty,
} from "../../helper/helper";
import {
    GET_STAFF_WORKLOADS_BY_ID_URL,
} from "../../env";
import moment from "moment/moment";


function ViewStaffWorkLoad({ viewStaffMemberData }) {
    const [staffMemberId, setStaffMemberId] = useState(viewStaffMemberData?.staffMember?._id)
    const [isLoading, setIsLoading] = useState(true);
    const [userData, setUserData] = useState([]);

    const [apiQuery, setApiQuery] = useState({
        staffMember: staffMemberId
    });


    useEffect(() => {
        setApiQuery({
            staffMember: staffMemberId
        });
    }, [viewStaffMemberData, staffMemberId])


    const processFetchRecords = (method, data) => {
        if (data?.status !== isSuccess) {

        } else if (method === "get" && data?.status === isSuccess) {
            const userData = data?.data || [];
            setUserData(userData);
            setIsLoading(false);
        }
    };

    const fetchAllRecords = catchAsync(async () => {
        try {
            const response = await getRecords(GET_STAFF_WORKLOADS_BY_ID_URL, apiQuery);
            
            processFetchRecords("get", response);
        } catch (error) {
            console.error("Error fetching staff workloads:", error);
        }
    });


    useEffect(() => {
        fetchAllRecords();
    }, []);

    const columns = [
        {
            name: "#",
            selector: (row, index) => <span>{index + 1}</span>,
            width: "5%",
            center: true,
        },

        {
            name: "Start Date",
            selector: (row) => {
                return <span>{moment(row?.startDate).format("DD/MM/YYYY")}</span>;
            },
            center: true,
        },
        {
            name: "End Date",
            selector: (row) => {
                return <span>{moment(row?.endDate).format("DD/MM/YYYY")}</span>;
            },
            center: true,
        },

        {
            name: "Allowed Hours",
            selector: (row) => {
                return <span>{row?.holidayAlwnNoOfHours === 0 ? row?.holidayAlwnNoOfHours : (row?.holidayAlwnNoOfHours.toFixed(2))}</span>;
            },
            center: true,
        },
        {
            name: "Availed Hours",
            selector: (row) => {
                return <span>{row?.holidayHoursAvailed === 0 ? row?.holidayHoursAvailed : (row?.holidayHoursAvailed.toFixed(2))}</span>;
            },
            center: true,
        },
        {
            name: "Remain Hours",
            selector: (row) => {
                return <span>{row?.holidayHoursRemaining === 0 ? row?.holidayHoursRemaining : (row?.holidayHoursRemaining.toFixed(2))}</span>;
            },
            center: true,
        },
        {
            name: "Carried Hours",
            selector: (row) => {
                return <span>{row?.carriedOverHours}</span>;
            },
            center: true,
        },
    ];


    const filteredColumns = filterColumns(columns, (column) => column !== null);
    const filteredRows = filterRowsByProperty(
        userData,
        (row) => row?.staffMember?.user?.name
    );

    return (
        <>
            <div className="mainContent rowClickUnset">
                <div className="dataTableWrapper">
                    <DataTable
                        className="maxWidthTable minWidthTable borderBottomTable"
                        columns={filteredColumns}
                        data={filteredRows}
                        fixedHeader
                        highlightOnHover
                        responsive={true}
                        progressPending={isLoading}
                        progressComponent={<ProgressComponent />}
                    />
                </div>
                <br />
            </div>
        </>
    );
}

export default ViewStaffWorkLoad;
